import { Injectable } from '@angular/core';
import { Subject, Subscription, lastValueFrom, of } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { EventStreamChange } from '../models/$event.model';
import { take, catchError, first } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { LogService } from "./log.service";
import { WFWorker, WorkforceGroup, JoiEvent, eventsFeature } from '../store/events.era';
import { Store, select } from '@ngrx/store';
import { WorkforceActions, workforceFeature, WorkforceState } from '../store/workforce.era';
import { doc, Firestore, setDoc } from '@angular/fire/firestore';
import { transformObservableToSinglePromise } from '../helpers/angular-helpers';
import { AccountsService } from './accounts.service';
import { NotificationsService } from "./notifications.service";
// import { ChangeNewWorkerStatus, WorkforceState } from '../store/workforce.era';
// import { removeFromListByIndex, jsonCopyObject, sleepForMS } from '../helpers/helpers';
import { EventPermissionsService } from './event.permissions.service';
import { PermissionAccess } from 'globals/store/permissions.data';
import { removeFromListByIndex, sleepForMS } from '../helpers/helpers';
import { ReinviteWorkerData } from 'globals/store/workforce.data';
import { User } from 'globals/store/user.data';
import { accountsFeature } from '../store/accounts.era';
import { TaskService } from './task.service';
// import { transformObservableToSinglePromise } from '../helpers/angular-helpers';
// import { traceNames } from './performance.tracking.data';
// import { User } from './../store/user.data';
import { EventService } from './event.service';
import { jsonCopyObject } from 'globals/helpers/helpers';
// import { getOneStorePromise } from './../store/store';
// import { ReinviteWorkerData } from '../store/workforce.data';
// import { accountsFeature } from '../store/accounts.store';


@Injectable({ providedIn: 'root' })
export class WorkforceService {

    readonly _file: string = 'workforce.service.ts';

    public showGroup = {};
    public workforceSortPreference = { by: 'user', direction: 'asc' }

    public NEW_ID = 'new id';
    public ADD_INVITE = 'add_invite';
    public INVITED = 'invited';
    public WORKFORCE_UPDATED = 'workforce_updated';
    public ADD_WORKFORCE_PROGRESS = 'workforce_progress';
    public WORKFORCE_LOADED = 'loaded';
    private WAIT_MS_BETWEEN_INVITES = 500

    public groups: Array<any> = [];
    public is_loading: Boolean = false;
    readonly api = `${environment.functionsURL}api/app`;

    new_message = '';
    include_tasks;
    extend_invite;
    invite_as_account_role: string;
    invite_valid = true;
    successMessage = '';
    errorMessage = null;
    showGroups = 'expand';
    showPeople = 'expand';
    picker_search = '';
    picker_state = null;
    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();

    private wf_groups: WorkforceGroup[] = []
    private workers: WFWorker[] = []
    private subscriptions: Subscription[] = []
    private currentEvent: JoiEvent

    constructor(
        private http: HttpClient,
        public store: Store,
        private db: Firestore,
        private notifications: NotificationsService,
        private accountService: AccountsService,
        private log: LogService,
        private eventPermissionsService: EventPermissionsService,
        private taskService: TaskService,
        // private perf:PerformanceTrackingService,
        private eventService: EventService
    ) {

      this.subscriptions.push(this.store.pipe(select(eventsFeature.selectEvent)).subscribe((event) => {
        this.currentEvent = event
      }))
      this.subscriptions.push(this.store.pipe(select(workforceFeature.selectWorkforce)).subscribe(( workforce) => {
        this.workers = workforce
        // this.setLegends()
      }))
      this.subscriptions.push(this.store.pipe(select(workforceFeature.selectWf_groups)).subscribe((wf_groups ) => {
        this.wf_groups = wf_groups
      }))
    }
    saveRole(worker?) {
      if(worker){
        this.workers = this.workers.map(w=>{
          if (w.email === worker.email) w.role = worker.role;
          return w;
        })
      }
      setDoc(doc(this.db, 'events/' + this.currentEvent.eventId), { workforce: this.workers }, { merge: true })
    }

    private addWorkerToWorkforceOnly(worker): Promise<any> {
      return new Promise((resolve, reject)=> {
        const updated_event_obj = { workforce: [{...worker, status: 'notInvited'}, ...this.workers] };
        this.workers = updated_event_obj.workforce;
        setDoc(doc(this.db, 'events', this.currentEvent.eventId), updated_event_obj).then(_ => {
          this.is_loading = false;
          resolve(false)
        }).catch(response => {
          this.log.error({file:this._file, function:'addWorker',response,error:new Error(),message:'There was an error adding the new worker'})
          this.is_loading = false;
          reject(response)
        })
      })
    }


    private dispatchInviteWorker(worker, permissions:PermissionAccess): Promise<any> {
      permissions = permissions ? permissions : this.eventPermissionsService.getBlankRestrictionsObject();
      return new Promise((resolve)=>{

        this.store.dispatch(WorkforceActions.changeNewWorkerStatus('sending'))
        const url = `${this.api}/invite-worker`;
        const extend_invite_to_account_role = this.extend_invite ? this.invite_as_account_role : false;

        let suppress_email = false;
        if (extend_invite_to_account_role) {
            suppress_email = true;
            const user = Object.assign({}, worker, { role: extend_invite_to_account_role, status:'sending' });
            const accountId = this.currentEvent.accountId;
            // console.log('user, accountId ', user, accountId);
            this.accountService.inviteUser(user, accountId).subscribe(() => {
                // console.log('Invited worker to account ',accountId,' as well.');
            }, (response) => {
                this.log.error({
                    file: this._file,
                    error: new Error(), function: 'inviteWorker extend_invite_to_account_role', response,
                    message: 'There was an error extending the invite to include account status. Please try adding this user in the accounts area.'
                })
            });
        }
        // console.log("Worker being invited through internal api with this data: ", { worker: worker, restrictions, eventId: this.currentEvent.eventId, message, suppress_email }) <== this is also called the right number of times
        this.http.post(url, { worker, permissions, eventId: this.currentEvent.eventId, suppress_email })
          .pipe(catchError(error => {
            console.error(error)
            return of()
          }), first()).subscribe(resolve)
      })
    }

    addWorkersToWorkforceOnly(workers) {
      this.is_loading = true
      workers.forEach(worker => worker.status = "notInvited")
      Promise.all(workers.map(worker => this.addWorkerToWorkforceOnly(worker)))
        .then(_ => {
          this.is_loading = false
          this.setSuccessMessage('notInvited', true)
        })
    }

    async addWorkerToWorkforce() { 
      this.is_loading = true
      const newWorker: WFWorker = await transformObservableToSinglePromise(this.store.select(workforceFeature.selectNewWorker))
      newWorker.status = 'notInvited'
      console.log({ newWorker })
      await this.addWorkerToWorkforceOnly(newWorker)
      this.setSuccessMessage('notInvited', false)
      this.is_loading = false
    }

    inviteWorkers(workers) {

      // console.log("INVITE WORKERS CALLED!", { newWorkers: workers, oldWorkers: jsonCopyObject(this.workers) })
      // this.perf.start(traceNames.actionWorkforce)
      this.is_loading = true
      const nWorkers = workers.length

      this.store.pipe(select(workforceFeature.selectWorkforceState), take(1)).subscribe(async({ newWorkerPermissions }:WorkforceState)=>{
        for (let i = 0; i < nWorkers; i++) {
          const worker = workers[i]
          worker.status = "invite_existing"
          this.dispatchInviteWorker(workers[i], newWorkerPermissions)
          // console.log('sleeping...')
          await sleepForMS(this.WAIT_MS_BETWEEN_INVITES)
        }
  
        this.setSuccessMessage('invite_existing', true)
        this.is_loading = false
        // this.perf.stop(traceNames.actionWorkforce, {attributes:[
        //   {name:"WorkersInvited", value:nWorkers.toString()},
        // ]})
      })


    }

    inviteWorker() { // adds worker on the round trip back in
      this.is_loading = true
      // this.perf.start(traceNames.actionWorkforce)
      this.store.pipe(select(workforceFeature.selectWorkforceState), take(1)).subscribe(({ newWorker, newWorkerPermissions }:WorkforceState)=>{
          const worker = jsonCopyObject(newWorker) as WFWorker
        worker.status = 'invite'
        this.dispatchInviteWorker(worker, newWorkerPermissions)
          .then(_ => {
            this.setSuccessMessage('invite', false)
            this.is_loading = false
            // this.perf.stop(traceNames.actionWorkforce, {attributes:[
            //   {name:"WorkersInvited", value:'1'},
            // ]})
          })
      })
    }

    async reinviteWorker(reinviteData: ReinviteWorkerData) {
      // this.perf.start(traceNames.actionWorkforce)
      const url = `${this.api}/reinvite-worker`
      try {
        await this.http.post(url, reinviteData).toPromise()
      } catch(error) {
        console.error(error)
      }
      // this.perf.stop(traceNames.actionWorkforce)
    }


    setSuccessMessage(type: string, multiple: boolean, msg?: string) {
        this.is_loading = false;
        this.store.dispatch(WorkforceActions.changeNewWorkerStatus(null))
        const user = multiple ? 'Users' : 'User';
        const invitation = multiple ? 'invitations were' : 'invitation was';
        switch (type) {
            case 'invite':
                this.successMessage = user + ' added and invite sent';
                break;
            case 'notInvited':
                this.successMessage = user + ' has been added but not yet invited.';
                break;
            case 'invite_existing':
                this.successMessage = 'Your ' + invitation + ' sent';
                break;
            default:
                if (msg) this.successMessage = msg;
        }
        setTimeout(_ => {
            this.successMessage = '';
        }, 12 * 1000);
    }

    attachUidToWorker(worker_or_email: any, uid: string) { // needed on add, invite, register
        for (let i = 0; i < this.workers.length; i++) {
            if (worker_or_email === this.workers[i] || worker_or_email === this.workers[i].email) {
                this.workers[i].uid = uid;
                if (!this.currentEvent) {
                    this.is_loading = false;
                    throw Error('No current event to add worker too');
                }
                // check if worker email has a uID
                const updated_event_obj = { workforce: this.workers };
                setDoc(doc(this.db, 'events/' + this.currentEvent.eventId), updated_event_obj, { merge: true });
                break;
            }
        }
    }


    createGroup(group): Promise<any> {
      this.wf_groups.push(group);
      return this.upsertWorkforceGroups(this.wf_groups)
    }


    modifyGroup(index, group): Promise<any> {
      const oldGroup = this.wf_groups[index]
      this.wf_groups[index] = group;
      if(oldGroup) this.taskService.renameWorkforceGroup(oldGroup, group)

      return this.upsertWorkforceGroups(this.wf_groups)
    }

    deleteGroup(index): Promise<any> {
      const oldGroup = this.wf_groups.splice(index, 1)[0]
      this.taskService.deleteWorkforceGroup(oldGroup)
      return this.upsertWorkforceGroups(this.wf_groups)
    }

    addGroup(group): Promise<any> {
      this.wf_groups.push(group)
      return this.upsertWorkforceGroups(this.wf_groups)
    }

    upsertWorkforceGroups = (wf_groups): Promise<any> => setDoc(doc(this.db, 'events/' + this.currentEvent.eventId), { wf_groups }, { merge: true })

    addMemberToGroup(email, idx): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.wf_groups[idx] && this.wf_groups[idx].members && this.wf_groups[idx].members.indexOf(email) === -1) {
                this.wf_groups[idx].members.push(email);
                setDoc(doc(this.db, 'events/' + this.currentEvent.eventId), { wf_groups: this.wf_groups }, { merge: true }).then(resolve).catch(reject)
            }else{
              resolve(false)
            }
        });
    }

    removeWorkerFromEventData(worker) {
      this.wf_groups.forEach(gr => removeFromListByIndex(gr.members, gr.members.findIndex(m => m === worker.email)))
      removeFromListByIndex(this.workers, this.workers.findIndex(w => w.email === worker.email))

      if (worker.uid) {
        removeFromListByIndex(this.currentEvent.users, this.currentEvent.users.findIndex(u => u === worker.uid))
        removeFromListByIndex(this.currentEvent.invitation, this.currentEvent.invitation.findIndex(invite => invite.receiver === worker.uid /*&& invite.status == 'pending'*/))
      }
    }
    removeManyFromEvent(workers) {
      console.log('Remove many from event called with workers: ', workers)
      workers.forEach(this.removeWorkerFromEventData.bind(this))
      const url = `${this.api}/remove-workers`;
        this.http.post(url, { emails: workers.map(w => w.email), eventId: this.currentEvent.eventId })
            .pipe(take(1))
            .subscribe(() => {
                this.is_loading = false;
            }, (response => {
                this.log.error(
                    {
                        file: this._file,
                        error: new Error(), function: 'removeFromEvent api/remove-workers',
                        response, message: "There was an error removing workforce members",
                        data: { workers, event: this.currentEvent }
                    })
            }))
    }
    async removeFromEvent(worker: WFWorker | User, event: JoiEvent, insideEvent = true) {
        // this gives the apperance that it all worked, but the api actually does the update <== well, at the moment the state is being mutated into what we want, but changes will not come out because there are no dispatches to the store.
        console.log({ worker, event, insideEvent })
        if (insideEvent) this.removeWorkerFromEventData(worker)
        if (worker.uid) this.notifications.makeNotification({ type: 'workforce', subtype: 'removed', recipients: [worker.uid] }, event); // <== unless we want to rewrite a bunch of stuff, this needs to happen here.  The reason is that there are other errors when a user removes THEMSELVES from an event (permissions errors for the event the user is no longer on), and to avoid them, you need to exit the event, and exiting the event makes errors in the notifications service which expects the event data to still be available (but when you exit the event that data is cleared), unless you call the notifications service before the event related permissions errors would occur, aka here.  In short, this needs to happen here, not after the api call below.

        const url = `${this.api}/remove-workers`;
        const accountIds: any[] = await lastValueFrom(this.store.select(accountsFeature.selectIds).pipe(take(1))) //  getOneStorePromise(this.store, select(accountsFeature.selectIds))
        if (event && event.accountId && accountIds.includes(event.accountId)) this.eventService.ignoreDeletesForEventForMS(event.eventId)

        this.http.post(url, { emails:[worker.email], eventId: event.eventId })
            .pipe(take(1))
            .subscribe(() => {
                // this.$events.next({ type: 'workforce', action: this.WORKFORCE_UPDATED } as EventStreamChange); <== not working
                
                this.is_loading = false;
            }, (response => {
                this.log.error(
                    {
                        file: this._file,
                        error: new Error(), function: 'removeFromEvent api/remove-worker',
                        response, message: "There was an error removing this workforce member",
                        data: { worker, event }
                    })
            }))
    }
    removeFromGroup(worker, group): Promise<any> {
        // return new Promise((resolve, reject) => {
        const pos = group.members.findIndex(m => m === worker.email);
        if (pos > -1) {
            group.members.splice(pos, 1);
        }
        return setDoc(doc(this.db, 'events/' + this.currentEvent.eventId), { wf_groups: this.wf_groups }, { merge: true });

        // });
    }
    isCurrentWorker(email): boolean {
        for (let i = 0; i < this.workers.length; i++) {
            if (this.workers[i].email === email) return true;
        }
        return false;
    }
    isInGroup(email, idx: number): boolean {
        let found = false;
        if (this.wf_groups[idx]) {
            const pos = this.wf_groups[idx].members.findIndex(m => m === email);
            if (pos > -1) {
                found = true;
            }
        }
        return found;
    }
    clearWorkforceFromCache() {
        this.workers = [];
        this.groups = [];
        this.$events.next({ type: 'workforce', action: this.WORKFORCE_LOADED } as EventStreamChange)
    }

    resetInviteVariables() {
        this.store.dispatch( WorkforceActions.changeNewWorkerStatus(null))
        this.new_message = '';
        this.errorMessage = null;
    }

    getProfile(worker) {
        const url = `${this.api}/get-profile`;
        return this.http.post(url, { worker });
    }

    loadWorkerProfile(): any {
        const url = `${this.api}/load-worker-profiles`;
				const workers = this.workers.filter(wf => wf.status === 'accepted').map(wf => wf.uid)
        return this.http.post(url, { workers });
    }
}
